// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__m8Vdf","tabletNav":"Layout_tabletNav__VxUf0"};